//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['resident'],
    data: function data() {
        return {
            persons: [],
            personOptions: [],
            person: '',
            wait: {}
        };
    },

    computed: {
        hasPerson: function hasPerson() {
            return this.person.length ? true : false;
        }
    },
    mounted: function mounted() {
        var $el = this;
        Event.$on('add-new-guest', function (item) {
            $el.unit = item;
            $el.$children[0].$data.showSmallModal = true;
            axios.get("/prototype/guest-cards").then(function (response) {
                $el.persons = response.data;

                var output = [];

                response.data.forEach(function (p) {

                    var item = {
                        label: p.full_name,
                        value: p.id
                    };

                    output.push(item);
                });

                $el.personOptions = output;
            });
        });
    },

    methods: {
        saveGuest: function saveGuest() {
            var _this = this;

            var $el = this;
            this.wait.guest_id = this.person.value;
            this.wait.guest_name = this.person.label;
            this.wait.unit_id = this.unit;
            axios.post("/prototype/addWait", {
                unit: this.wait
            }).then(function (response) {
                if (response.data) {
                    _this.$snotify.success('The New Guest was added');
                    Event.$emit('close-small-modal');
                    Event.$emit('view-unit-refresh', _this.unit);
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/unit/UnitAddWait.vue
// module id = YlNL
// module chunks = 0 1